export const loanPipelineSet = (state) => {
  return {
    type: "SET_LOAN_PIPELINE",
    payload: state,
  };
};

export const loanPipelineSetKey = ({ key, value }) => {
  return {
    type: "SET_LOAN_PIPELINE_KEY",
    payload: { key, value },
  };
};

export const loanPipelineUpdateField = ({ loanId, field, value }) => {
  return {
    type: "UPDATE_LOAN_PIPELINE_FIELD",
    payload: { loanId, field, value },
  };
};

export const loanPipelineClear = () => {
  return {
    type: "CLEAR_LOAN_PIPELINE",
  };
};
